export default __webpack_public_path__ + "static/media/plusCircle.37020031.svg";